export enum CampaignStrategy {
  Similars = 'similars',
  Collections = 'collections',
  CompleteTheLook = 'ctl',
  ShopTheLook = 'stl',
  FrequentlyBoughtTogether = 'fbt',
  RecentlyViewed = 'recently_viewed',
}
